export default __webpack_public_path__ + "static/media/Background.d04eef59.png";